import React from 'react';

import { useSelector } from 'react-redux';

import { DevActivityIcon } from 'src/components/jira/dev-activity-icon/dev-activity-icon';
import { DevActivity } from 'src/redux/jira/types';
import { BucketState } from 'src/types/state';

type Props = {
  cloudId: string;
  issueId: string;
};

export const DevActivityComponent = ({ cloudId, issueId }: Props) => {
  const activity = useSelector<BucketState, DevActivity>(
    state => (state.jira.jiraRepoPage.devActivity[cloudId] || {})[issueId]
  );

  if (!activity) {
    return null;
  }

  return <DevActivityIcon devActivity={activity} />;
};
